import { reactive, computed } from 'vue'
import { useOptimizedImage, FIT_CROP } from './useOptimizedImage'

const Seo = reactive({
  title: null,
  description: '',
  defaultDescription: '',
  image: null,
  defaultImage: null,
  siteTitle: 'Loading...',
  separator: '|'
})

const setSeoDefaults = ({ siteTitle, description, image, separator }) => {
  Seo.siteTitle = siteTitle || Seo.siteTitle
  Seo.separator = separator || Seo.separator
  Seo.defaultDescription = description || Seo.defaultDescription

  if (image) {
    if (typeof image === 'object') {
      const { url } = useOptimizedImage(image, { width: 1200, height: 625, format: 'jpg', fit: FIT_CROP })
      Seo.defaultImage = `https://${SERVICE_TARGET_DOMAIN}${url}`
    } else {
      Seo.defaultImage = image
    }
  }
}

const setSeo = ({ title, description, image }) => {
  Seo.title = title
  Seo.description = description
  if (image) {
    if (typeof image === 'object') {
      const { url } = useOptimizedImage(image, { width: 1200, height: 625, format: 'jpg', fit: FIT_CROP })
      Seo.image = `https://${SERVICE_TARGET_DOMAIN}${url}`
    } else {
      Seo.image = image
    }
  }
}

const getReactiveSeo = () => {
  return {
    title: computed(() => (Seo.title ? `${Seo.title} ${Seo.separator} ${Seo.siteTitle}` : Seo.siteTitle)),
    description: computed(() => Seo.description || Seo.defaultDescription),
    image: computed(() => Seo.image || Seo.defaultImage)
  }
}

const exportedObject = {
  getReactiveSeo,
  setSeo,
  setSeoDefaults
}

export const useSeo = () => {
  return exportedObject
}

export default useSeo
